(function (root, factory) {
  'use strict';

  if (typeof module === 'object' && module.exports) {
    module.exports = { createCardMediaHost: factory };
    return;
  }

  root.SAProductCardMedia = factory(root);
}(typeof globalThis !== 'undefined' ? globalThis : this, function createCardMediaHost(root) {
  'use strict';

  var records = new WeakMap();
  var sequence = 0;
  var observer = null;
  var nearObserver = null;
  var stopped = false;
  var document = root.document;

  function collect(scope) {
    var cards = [];
    if (!scope) return cards;
    if (scope.nodeType === 1 && scope.matches && scope.matches('[data-sa-product-card]')) {
      cards.push(scope);
    }
    if (scope.querySelectorAll) {
      Array.prototype.push.apply(cards, scope.querySelectorAll('[data-sa-product-card]'));
    }
    return cards;
  }

  function paint(record, state) {
    var isAudible = state.audible.clipId === 'on' || state.audible.clipId === 'off';
    var playing = state.desired.playing;
    var loading = state.status === 'loading' || state.status === 'preparing';
    var failed = state.status === 'error';
    var effectOn = state.desired.clipId === 'on';
    record.shell.classList.toggle('is-playing', playing);
    record.shell.classList.toggle('is-loading', loading);
    record.shell.classList.toggle('is-error', failed);
    record.shell.classList.toggle('is-effect-on', effectOn);
    record.shell.classList.toggle('is-expanded', playing);
    record.toggle.setAttribute(
      'aria-label',
      (playing ? 'Pause ' : 'Play ') + record.title + ' demo'
    );
    if (record.mode) {
      record.mode.setAttribute('aria-checked', effectOn ? 'true' : 'false');
      record.mode.setAttribute('aria-label', record.title + ' in mix');
    }

    var duration = isAudible ? state.audible.durationSeconds : 0;
    var position = isAudible ? state.audible.positionSeconds : state.desired.positionSeconds;
    var ratio = duration > 0 ? Math.min(1, Math.max(0, position / duration)) : 0;
    if (record.progress) record.progress.style.transform = 'scaleX(' + ratio.toFixed(4) + ')';
    if (record.track) record.track.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
  }

  function prepare(record, priority) {
    if (stopped || records.get(record.card) !== record) return;
    var connection = root.navigator && root.navigator.connection;
    if (priority !== 'user' && connection && (connection.saveData ||
        /^(slow-2g|2g|3g)$/.test(connection.effectiveType))) return;
    record.session.prepare(['on', 'off'], { priority: priority }).catch(function () {});
  }

  function watchNearCard(record) {
    if (!root.IntersectionObserver) return;
    if (!nearObserver) {
      nearObserver = new root.IntersectionObserver(function (entries) {
        if (stopped || !nearObserver) return;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio <= 0) return;
          var current = records.get(entry.target);
          if (current) prepare(current, 'near');
          nearObserver.unobserve(entry.target);
        });
      }, { rootMargin: '160px 0px', threshold: 0.01 });
    }
    nearObserver.observe(record.card);
  }

  function bindCard(card) {
    if (records.has(card) || !root.SAMediaPlayback) return false;
    var shell = card.querySelector('[data-media-playback-card]');
    if (!shell) return false;
    var onUrl = shell.getAttribute('data-media-playback-url');
    var offUrl = shell.getAttribute('data-media-playback-off-url');
    var toggle = shell.querySelector('[data-card-audio-toggle]');
    var mode = shell.querySelector('[data-card-audio-mode]');
    if (!onUrl || !offUrl || !toggle || !mode) return false;

    var handle = card.getAttribute('data-product-handle') || 'product';
    var timelineId = 'product-card-' + handle;
    var session = root.SAMediaPlayback.createSession({
      id: 'sa-product-card-' + handle + '-' + (++sequence),
      clips: [
        { id: 'off', url: offUrl, timelineId: timelineId },
        { id: 'on', url: onUrl, timelineId: timelineId }
      ],
      initialClipId: 'on'
    });
    var record = {
      card: card,
      shell: shell,
      toggle: toggle,
      mode: mode,
      progress: shell.querySelector('[data-card-audio-progress]'),
      track: shell.querySelector('[data-card-audio-track]'),
      title: card.dataset.title || 'Product',
      session: session,
      unsubscribe: null,
      onToggle: null,
      onMode: null,
      onIntent: null
    };

    record.onToggle = function () {
      var state = session.state;
      var playing = state.status === 'error' || !state.desired.playing;
      session.set({ playing: playing });
      if (playing) prepare(record, 'user');
    };
    record.onMode = function () {
      var state = session.state;
      session.set({ clipId: state.desired.clipId === 'on' ? 'off' : 'on' });
    };
    record.onIntent = function () { prepare(record, 'user'); };
    toggle.addEventListener('click', record.onToggle);
    mode.addEventListener('click', record.onMode);
    toggle.addEventListener('pointerenter', record.onIntent);
    toggle.addEventListener('focus', record.onIntent);
    toggle.addEventListener('pointerdown', record.onIntent, { passive: true });
    record.unsubscribe = session.subscribe(function (state) { paint(record, state); });
    records.set(card, record);
    shell.hidden = false;
    watchNearCard(record);
    return true;
  }

  function bind(scope) {
    if (stopped || !root.SAMediaPlayback) return 0;
    var count = 0;
    collect(scope).forEach(function (card) {
      if (bindCard(card)) count += 1;
    });
    return count;
  }

  function destroyCard(card) {
    var record = records.get(card);
    if (!record) return false;
    records.delete(card);
    if (nearObserver) nearObserver.unobserve(card);
    record.toggle.removeEventListener('click', record.onToggle);
    record.mode.removeEventListener('click', record.onMode);
    record.toggle.removeEventListener('pointerenter', record.onIntent);
    record.toggle.removeEventListener('focus', record.onIntent);
    record.toggle.removeEventListener('pointerdown', record.onIntent);
    if (record.unsubscribe) record.unsubscribe();
    record.session.destroy();
    record.shell.classList.toggle('is-playing', false);
    record.shell.classList.toggle('is-loading', false);
    record.shell.classList.toggle('is-error', false);
    record.shell.classList.toggle('is-effect-on', false);
    record.shell.classList.toggle('is-expanded', false);
    record.shell.hidden = true;
    return true;
  }

  function destroy(scope) {
    var count = 0;
    collect(scope || document).forEach(function (card) {
      if (destroyCard(card)) count += 1;
    });
    if (!scope || scope === document) {
      stopped = true;
      if (observer) observer.disconnect();
      observer = null;
      if (nearObserver) nearObserver.disconnect();
      nearObserver = null;
    }
    return count;
  }

  function boot() {
    if (stopped || !document) return;
    bind(document);
    if (!root.SAMediaPlayback && root.addEventListener) {
      root.addEventListener('load', function () { bind(document); }, { once: true });
    }
    if (!root.MutationObserver || !document.documentElement) return;
    observer = new root.MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.removedNodes || [], function (node) {
          collect(node).forEach(destroyCard);
        });
      });
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], bind);
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  }

  return Object.freeze({ bind: bind, destroy: destroy });
}));
